import React from 'react';
import styled, { css } from 'styled-components';

interface IProps {
  oval: boolean;
  width: number;
  height: number;
  isLandscape: boolean;
}

const CameraHighlight = ({ oval, width, height, isLandscape }: IProps) => {
  return !oval ? (
    <Overlay width={width} height={height} isLandscape={isLandscape}>
      <Corner pos="topRight" />
      <Corner pos="topLeft" />
      <Corner pos="botRight" />
      <Corner pos="botLeft" />
    </Overlay>
  ) : (
    <Overlay oval width={width} isLandscape={isLandscape} />
  );
};

export default CameraHighlight;

const Overlay = styled.div<{
  oval?: boolean;
  width: number;
  height?: number;
  isLandscape: boolean;
}>`
  position: absolute;
  inset: ${({ oval }) => (oval ? '14rem' : '8rem')};
  box-shadow: 0 0 2rem 50rem rgba(0, 0, 0, 0.5);

  ${({ oval }) =>
    oval &&
    css`
      width: 50%;
      height: 80%;
      border-radius: 50%;
      margin: 0 auto;
      top: 46%;
      left: 50%;
      right: unset;
      bottom: unset;
      transform: translate(-50%, -50%);
    `};

  ${({ theme, oval, isLandscape }) =>
    theme.view.isMobile &&
    oval &&
    css`
      bottom: unset;
      right: unset;
      left: 50%;
      width: ${isLandscape ? '20%' : '90%'};
      height: 65%;
      top: 45%;
      transform: translate(-50%, -50%);
    `}

  ${({ theme, oval, width, height, isLandscape }) =>
    theme.view.isMobile &&
    !oval &&
    css`
      height: ${isLandscape ? height && `${height / 10}rem` : '55%'};
      width: ${isLandscape ? '50%' : width && `${width / 10}rem`};
      bottom: unset;
      right: unset;
      left: 50%;
      top: 46%;
      transform: translate(-50%, -50%);
    `}
`;

const Corner = styled.div<{ pos: string }>`
  position: absolute;
  width: 8rem;
  height: 8rem;
  border: 0.6rem solid ${({ theme }) => theme.colors.white};

  ${({ pos }) =>
    pos === 'topRight' &&
    css`
      top: -0.6rem;
      right: -0.6rem;
      border-left: unset;
      border-bottom: unset;
    `}

  ${({ pos }) =>
    pos === 'topLeft' &&
    css`
      top: -0.6rem;
      left: -0.6rem;
      border-right: unset;
      border-bottom: unset;
    `}

    ${({ pos }) =>
    pos === 'botRight' &&
    css`
      bottom: -0.6rem;
      right: -0.6rem;
      border-left: unset;
      border-top: unset;
    `}

    ${({ pos }) =>
    pos === 'botLeft' &&
    css`
      bottom: -0.6rem;
      left: -0.6rem;
      border-right: unset;
      border-top: unset;
    `}
`;
